export const calculateDimensions = (url) => new Promise((resolve, reject) => {
  const image = new Image();

  image.src = url;
  image.onload = () => {
    resolve({
      width: image.width,
      height: image.height,
    });
  };

  image.onerror = () => reject();
});
